import { PasswordRule } from "components/blocks/bubble/PasswordBubble";
import { checkEmpty } from "./functions";

// 이메일 정규식 check
export const checkEmailRegEx = (email: string) => {
  // let regex = new RegExp(
  //   "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
  // );
  if (checkEmpty(email)) {
    return false;
  }
  if ((email || "").split("@").length > 2) {
    return false;
  }
  if (
    email.includes(" ") ||
    email.includes("..") ||
    email.startsWith(".") ||
    email.startsWith("@")
  ) {
    return false;
  }
  const regex =
    /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)(?:\.(?:[a-zA-Z](?:[a-zA-Z0-9-]*[a-zA-Z])?))+$/;
  const [local, domain] = email.split("@") || [];

  if (checkEmpty(domain) || checkEmpty(local)) {
    return false;
  }
  if (local.startsWith(".") || local.endsWith(".")) {
    return false;
  }
  if (domain.startsWith(".") || domain.endsWith(".")) {
    return false;
  }
  if (
    domain.split(".").some((part) => part.startsWith("-") || part.endsWith("-"))
  ) {
    return false;
  }
  if (!domain.includes(".")) {
    return false;
  }

  const forbiddenChars = /[<>"()[\]\\`,;:/]/;
  if (forbiddenChars.test(local)) {
    return false;
  }

  return regex.test(email);
};

// 비밀번호 정규식 대문자 & 소문자 check
export const checkPasswordRegEx = (password: string) => {
  let upperandLowerLetterRegEx = /(?=.*[a-z])(?=.*[A-Z])/;
  // console.log(password, upperandLowerLetterRegEx.test(password), "letter");
  return upperandLowerLetterRegEx.test(password);
};

// 비밀번호 숫자 || SPECIAL CHARACTER check
export const checkPasswordNumberRegEx = (password: string) => {
  let numberRegEx =
    /(?=.*?[0-9])(?=.*?[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"])/;
  // console.log(password, numberRegEx.test(password), "number");
  return numberRegEx.test(password);
};

/**
 *  공백체크 정규식.
 */
export const checkWhiteSpaceRegEx = (str: string) => {
  const regex = /^\s+|\s+$/g;
  if (str.replace(regex, "") === "") return true;
  else return false;
};

export const validateYoutubeUrl = (url: string) => {
  if (!url) {
    return false;
  }
  const regex =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  const regex2 =
    /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)[\w-]{11}(\S+)?$/;
  if (url.match(regex)) {
    return true;
  }
  if (url.match(regex2)) {
    return true;
  }
  return false;
};

export const validateVimeoUrl = (url: string) => {
  const regex = /^(https?:\/\/)?(www\.)?(vimeo\.com\/)?([0-9]+)$/;
  const regex2 =
    /^(https?:\/\/)?(www\.)?(player\.vimeo\.com\/video\/)?([0-9]+)$/;
  if (url.match(regex)) {
    return true;
  }
  if (url.match(regex2)) {
    return true;
  }
  return false;
};

export const checkMacAddressRegex = (macAdd: string) => {
  const regex = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;
  return regex.test(macAdd || "");
};

export const orgNameRule = (orgName: string) => {
  return !/^[a-zA-Z0-9()_\-+=[\]{} &]+$/.test(orgName);
};

export const orgNameAlphabetRule = (orgName: string) => {
  return !/[a-zA-Z]/.test(orgName);
};

export const orgNameRules: PasswordRule[] = [
  {
    label: "3-100 characters",
    condition: (orgName: string) => orgName.length < 3 || orgName.length > 100,
  },
  {
    label: "Allowed chars: ( ) _ - + = [ ] { } &",
    condition: (orgName: string) => orgNameRule(orgName),
  },
  {
    label: "At least one alphabet character",
    condition: (orgName: string) => orgNameAlphabetRule(orgName),
  },
];

export const PRICE_REGEX = /^(?:|[1-9]\d{0,7}(?:\.\d{0,2})?)$/;
